import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
import { AutoLoginGuard } from './guards/auto-login.guard';
import { UserResolver } from './resolvers/user.resolver';
import { LoginPage } from './public/login/login.page';
import { AccessDeniedPage } from './public/access-denied/access-denied.page';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    component: LoginPage,
    canActivate: [AutoLoginGuard]
  },
  {
    path: 'private',
    loadChildren: () => import('./private/private-routing.module').then(m => m.PrivateRoutingModule),
    canActivate: [AuthGuard],
    resolve: { user: UserResolver }
  },
  {
    path: 'claim',
    loadComponent: () => import('./public/auth/claim/claim.page').then(m => m.ClaimPage)
  },
  {
    path: 'forgot',
    loadComponent: () => import('./public/auth/forgot/forgot.page').then(m => m.ForgotPage)
  },
  {
    path: 'reset',
    loadComponent: () => import('./public/auth/reset/reset.page').then(m => m.ResetPage)
  },
  {
    path: 'register',
    loadChildren: () => import('./public/register/register.module').then(m => m.RegisterPageModule)
  },
  {
    path: 'welcome',
    loadChildren: () => import('./public/welcome/welcome.module').then(m => m.WelcomePageModule),
    canActivate: [AutoLoginGuard]
  },
  {
    path: 'access-denied',
    component: AccessDeniedPage
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
